export interface UiState {
  headerState: HeaderState;
}

export const initialState: UiState = {
  headerState: getInitialHeaderState(),
};

export interface HeaderState {
  visibleOrganizationInfo: boolean;
}

function getInitialHeaderState(): HeaderState {
  return {
    visibleOrganizationInfo: false,
  };
}
